import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();
  return (
    <footer className="footer">
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-6">{currentYear} © Billing System.</div>
          <div className="col-sm-6">
            <div className="text-sm-end d-none d-sm-block">
              Design & Develop by DIGITALWEB | 
              <Link to="/terms-of-service" className="ms-2">Terms of Service</Link> | 
              <Link to="/privacy-policy" className="ms-2">Privacy Policy</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}